import { useEffect, useState } from 'react';
import { Card, Avatar, Row, Col } from 'antd';
import { Link, useHistory, useParams } from 'react-router-dom';
import { HomeOutlined } from '@ant-design/icons';
import getTranslatedText from '../helpers/getTranslatedText';
import translations from '../translations';

const { Meta } = Card;
const colors = ['red', 'brown', 'chocolate', 'green'];
const imagesBaseURL = 'https://cdn.iconscout.com/icon/premium/png-64-thumb';
const imageLinks = [
  'arabian-2390152-2004112.png',
  'arabian-2388490-2004241.png',
  'muslim-man-2585126-2156018.png',
  'man-2564765-2141963.png',
];

function MessageCards({ totalMessages }) {
  const [messages, setMessages] = useState(totalMessages);
  useEffect(() => {
    setMessages(totalMessages);
  }, [totalMessages]);

  const history = useHistory();
  const { lang } = useParams();

  return (
    <div>
      <h1>{getTranslatedText(translations, 'messageCardsTitle', lang)}</h1>

      <Row justify="space-around">
        {messages.length === 0 &&
          Array(10)
            .fill(0)
            .map((_, index) => (
              <Card
                style={{ width: 300, margin: '16px  5px' }}
                key={index}
                loading
              >
                <Meta
                  avatar={
                    <Avatar
                      src={`${imagesBaseURL}/${
                        imageLinks[
                          Math.floor(Math.random() * imageLinks.length)
                        ]
                      }`}
                    />
                  }
                />
              </Card>
            ))}

        {messages
          .sort((a, b) => (a.content.length > b.content.length ? 1 : -1))
          .map((message, index) => (
            <Col style={{ width: 300, margin: '16px  5px' }} key={index}>
              <Card
                hoverable
                onClick={() => history.push(`/${lang}/${message._id}`)}
                style={{ borderRadius: '12px', height: '150px' }}
              >
                <Meta
                  avatar={
                    <Avatar
                      src={`${imagesBaseURL}/${
                        imageLinks[
                          Math.floor(Math.random() * imageLinks.length)
                        ]
                      }`}
                    />
                  }
                  title={message.name}
                  description={
                    <span
                      style={{
                        color:
                          colors[Math.floor(Math.random() * colors.length)],
                        fontSize: `14px`,
                      }}
                    >
                      {message.content}
                    </span>
                  }
                />
              </Card>
            </Col>
          ))}
      </Row>
      <Link to="/:" title="Home" id="home-btn">
        <HomeOutlined style={{ fontSize: '25px', color: 'white' }} />
      </Link>
    </div>
  );
}
export default MessageCards;
